module.exports = __webpack_public_path__ + "img/money_transfer_.75e7c2b5.svg";